module.exports = __webpack_public_path__ + "img/81.coffee_tea.cb0f6e45.svg";